<sales-ui-filter-chip-container>
  <sales-ui-filter-chip
    (clicked)="openSalespeopleSelector()"
    (delete)="clearSalespeopleFilters()"
    *ngIf="(showSalespeopleAndTeams$ | async) && selectedSalespeopleNames$ | async as names"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.COMMON.SALESPEOPLE_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">{{ names }}</filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openSalesTeamSelector()"
    (delete)="clearSalesTeamFilters()"
    *ngIf="(showSalespeopleAndTeams$ | async) && selectedSalesTeamNames$ | async as names"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.COMMON.SALES_TEAM_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">{{ names }}</filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openAssignedDateSelector()"
    (delete)="clearAssignedDateFilter()"
    *ngIf="assignedDateFilter$ | async"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.PIPELINE.ASSIGNED_DATE_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">
      {{ assignedDateFilterToString$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openPipelineStatusSelector()"
    (delete)="clearPipelineStatuses()"
    *ngIf="(hasSelectedStatuses$ | async) === true"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.PIPELINE.STATUS_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">
      {{ selectedStatusesNames$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openPackageSelector()"
    (delete)="clearPackageFilter()"
    *ngIf="(selectedPackages$ | async)?.length > 0"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.COMMON.PACKAGES_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">
      {{ selectedPackagesNames$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openProductSelector()"
    (delete)="clearProductsFilter()"
    *ngIf="(selectedProducts$ | async)?.length > 0"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.COMMON.PRODUCTS_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">
      {{ selectedProductNames$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openTagSelector()"
    (delete)="clearTagFilter()"
    *ngIf="selectedTags$ | async as tags"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.TAG' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">{{ tags }}</filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openPipelineSelector()"
    (delete)="clearPipelinesFilter()"
    *ngIf="(pipelinesSelectedFilter$ | async)?.length > 0"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINES' | translate }}:</filter-chip-title>
    <filter-chip-value>{{ selectedPipelineNames$ | async }}</filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openExpectedCloseSelector()"
    (delete)="clearExpectedCloseFilter()"
    *ngIf="expectedCloseFilter$ | async"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.PIPELINE.EXPECTED_CLOSE_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value>
      {{ expectedCloseFilterToString$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>
  <sales-ui-filter-chip
    (clicked)="openCreatedDateSelector()"
    (delete)="clearCreatedDateFilter()"
    *ngIf="createdDateFilter$ | async"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.PIPELINE.CREATED_DATE_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value>
      {{ createdDateFilterToString$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openOpportunityTypeFilter()"
    (delete)="clearOpportunityTypeFilter()"
    *ngIf="(selectedTypes$ | async)?.length > 0"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.PIPELINE.TYPE_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">
      {{ selectedTypeNames$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openActualCloseSelector()"
    (delete)="clearActualCloseFilter()"
    *ngIf="actualCloseFilter$ | async"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.PIPELINE.ACTUAL_CLOSE_LABEL' | translate }}:</filter-chip-title>
    <filter-chip-value>
      {{ actualCloseFilterToString$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <sales-ui-filter-chip
    (clicked)="openAccountGroupFilter()"
    (delete)="clearAccountGroupFilter()"
    *ngIf="selectedAccountGroupName$ | async"
    [canRemove]="true"
  >
    <filter-chip-title>{{ 'FRONTEND.SALES_UI.ACCOUNT' | translate }}:</filter-chip-title>
    <filter-chip-value class="chip-value">
      {{ selectedAccountGroupName$ | async }}
    </filter-chip-value>
  </sales-ui-filter-chip>

  <filter-menu-items>
    <button (click)="openAccountGroupFilter()" mat-menu-item>{{ 'FRONTEND.SALES_UI.ACCOUNT' | translate }}...</button>
    <button
      (click)="openOpportunityTypeFilter()"
      data-action="types-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.PIPELINE.TYPE_LABEL' | translate }}...
    </button>
    <ng-container *ngIf="showSalespeopleAndTeams$ | async">
      <button
        (click)="openSalespeopleSelector()"
        data-action="sales-people-filter"
        data-action-group="filter-menu-item"
        mat-menu-item
      >
        {{ 'FRONTEND.SALES_UI.COMMON.SALESPEOPLE_LABEL' | translate }}...
      </button>
      <button
        (click)="openSalesTeamSelector()"
        data-action="salesteams-filter"
        data-action-group="filter-menu-item"
        mat-menu-item
      >
        {{ 'FRONTEND.SALES_UI.COMMON.SALES_TEAM_LABEL' | translate }}...
      </button>
    </ng-container>
    <button
      (click)="openPipelineStatusSelector()"
      data-action="pipeline-status-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.PIPELINE.STATUS_LABEL' | translate }}...
    </button>
    <button
      (click)="openPackageSelector()"
      data-action="packages-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.COMMON.PACKAGES_LABEL' | translate }}...
    </button>
    <button
      (click)="openProductSelector()"
      data-action="products-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.COMMON.PRODUCTS_LABEL' | translate }}...
    </button>
    <button (click)="openTagSelector()" data-action="tags-filter" data-action-group="filter-menu-item" mat-menu-item>
      {{ 'FRONTEND.SALES_UI.TAG' | translate }}...
    </button>
    <button
      (click)="openPipelineSelector()"
      data-action="pipeline-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINES' | translate }}...
    </button>
    <button
      (click)="openExpectedCloseSelector()"
      data-action="expected-close-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.PIPELINE.EXPECTED_CLOSE_LABEL' | translate }}...
    </button>
    <button
      (click)="openActualCloseSelector()"
      data-action="actual-close-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.PIPELINE.ACTUAL_CLOSE_LABEL' | translate }}...
    </button>
    <button
      (click)="openCreatedDateSelector()"
      data-action="created-date-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.PIPELINE.CREATED_DATE_LABEL' | translate }}...
    </button>
    <button
      (click)="openAssignedDateSelector()"
      data-action="assigned-date-filter"
      data-action-group="filter-menu-item"
      mat-menu-item
    >
      {{ 'FRONTEND.SALES_UI.PIPELINE.ASSIGNED_DATE_LABEL' | translate }}...
    </button>
  </filter-menu-items>
</sales-ui-filter-chip-container>
